export default "__VITE_ASSET__CAIFtQ0O__"